// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useFeatureFlag } from './useFeatureFlag';
import { useFlagsReady } from './useFlagsReady';
import { LD_FLAGS, type LDFlagName } from '../config/launchDarklyFlags';
import { envFlagDefault } from '../config/featureFlags';

/**
 * Read of a default-on kill switch (see the header of config/launchDarklyFlags.ts).
 *
 * Until LaunchDarkly has answered for the current identity, `useFeatureFlag` can
 * still be serving the anonymous identity's or the previous site's value, which may
 * be `false` for a flag that will evaluate to `true` for the real one. So until
 * ready this returns the environment (`REACT_APP_FLAG_*`) value, else the catalog
 * default, and only then LaunchDarkly's: a deep link is not sent away on a stale
 * `false`, and a LaunchDarkly that never answers leaves the surface at its default.
 */
export function useKillSwitch(name: LDFlagName): boolean {
  const ready = useFlagsReady();
  const flag = useFeatureFlag(name);
  return ready ? flag : (envFlagDefault(name) ?? LD_FLAGS[name].default);
}
